export interface ISelectionTarget {
  associationId?: string;
  assessmentId?: string;
  ageGroupIds?: string[];
  ageGroupId?: string;
  playerAssessmentId?: string;
  assessmentSessionId?: string;
  drillId?: string;
  calibrationAssignmentId?: string;
}

export type ISelectionTargetInput = Omit<ISelectionTarget, 'associationId'> & { companyId?: string };

export enum SelectionTargetRefusal {
  NOT_FOUND = 'NOT_FOUND',
  CONFLICT = 'CONFLICT',
  MISSING_PERMISSION = 'MISSING_PERMISSION',
}

export interface IActiveSelection {
  activeCompanyId?: string | null;
  activeAssessmentId?: string | null;
  activeAgeGroupIds?: string[];
}

export interface ISelectionTargetResult {
  granted: boolean;
  reason: SelectionTargetRefusal | null;
  skippedIdCount: number;
  user: { _id: string; settings: IActiveSelection } | null;
}

export interface ICachedSelectionScope {
  companyId?: string | null;
  assessmentId?: string;
  ageGroupId?: string;
}

export enum SelectionTargetAction {
  NONE = 'NONE',
  APPLY = 'APPLY',
  SETTLE = 'SETTLE',
  SKIP_OFFLINE = 'SKIP_OFFLINE',
}
